import {SetGetHistoryReplenishment} from './thunk/setGetHistoryReplenishment';
import {SetGetHistoryWithdrawals} from './thunk/setGetHistoryWithdrawals';
import {SetGetUserProfile} from './thunk/setGetUserProfile';

export const Thunks = {
    SetGetHistoryReplenishment,
    SetGetHistoryWithdrawals,
    SetGetUserProfile
}